import AlertBell from '../src/AlertBell';
export default AlertBell;
